<template>
  <div :class="{ 'document-detail-header-box': showInBox, 'document-detail-floating-header': floatingHeader }">
    <div id="document-meta">
      <h4>{{ clazz }}</h4>
      <h6 class="font-weight-bold mt-1">{{ numero_tol }}</h6>
      <slot></slot>
      <h4 v-if="has_tituloarticulo" id="titulo-articulo">{{ tituloarticulo }}</h4>
    </div>
    <div class="header-fields">
      <div
        v-for="header in headerFieldsFiltered()"
        :class="header_field_class(header)"
        :key="get_header_key(header.id)"
      >
        <span class="label mt-2 font-weight-bold">
          {{ field_label(header) }}
        </span>
        <span class="value" v-html="headerValue(header.value)" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'documents-header-vue',
  props: {
    clazz: { type: String, default: "" },
    tituloarticulo: { type: String, default: "" },
    header_fields: { type: Array, default: () => [] },
    showInBox: { type: Boolean, default: false },
    floatingHeader: { type: Boolean, default: false },
    numero_tol: { type: String, default: '' }
  },
  computed: {
    has_tituloarticulo() { return !!this.tituloarticulo },
  },
  methods: {
    field_label : ({ label, value_type }) => label + (value_type == "boolean" ? "" : ":"),
    header_field_class: ({ id, normalized_value }) => (
      normalized_value ? `header_field_${id}_${normalized_value}` : ""
    ),
    headerValue(value){
      return value == 'true' ? '' : value
    },
    get_header_key: id => `header_field_${id}`,
    headerFieldsFiltered() {
      return this.header_fields.filter((header) => header.value !='false')
    }
  }
}
</script>

